import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
// item / icons
import { noImgPlaceholder } from "../../../common/vector";

interface AppTransportCardProps {
  onClick: () => void;
  image: { url: string };
  dataCyAttribute: string;
  name?: string;
  customColor?: string;
}

export default function AppTransportCard({
  onClick,
  image,
  dataCyAttribute,
  name,
  customColor
}: AppTransportCardProps) {
  return (
    <Grid item xs={12} md={12} lg={6}>
      <Box onClick={onClick} className="provider-box" data-cy={dataCyAttribute}>
        <div className="provider-box__image">
          {image?.url ? (
            <img src={image?.url} className="provider-image" alt="provider-img" />
          ) : (
            <img className="provider-image" src={noImgPlaceholder} alt="no-img-placeholder-provider" />
          )}
        </div>
        <Box className="provider-box__name" sx={{ backgroundColor: customColor }} data-cy={`${dataCyAttribute}-name`}>
          <div className="provider-box__name__text">{name}</div>
        </Box>
      </Box>
    </Grid>
  );
}
